import { Component, type ReactNode, type ErrorInfo } from 'react';
import { postClientError } from '../api/client';

interface Props { children: ReactNode }
interface State { hasError: boolean }

export default class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    postClientError({
      level: 'error',
      message: error.message,
      stack: error.stack,
      url: window.location.href,
      component: info.componentStack?.split('\n').find(l => l.trim())?.trim(),
    });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          display: 'flex', flexDirection: 'column', alignItems: 'center',
          justifyContent: 'center', height: '100vh',
          background: 'var(--bg, #0f0f23)', color: '#fff',
          padding: '2rem', textAlign: 'center',
        }}>
          <h2 style={{ marginBottom: '0.5rem' }}>Something went wrong</h2>
          <p style={{ color: 'rgba(255,255,255,0.6)', marginBottom: '1.5rem' }}>
            Please reload the page. If the problem persists, contact support.
          </p>
          <button
            onClick={() => window.location.reload()}
            style={{
              padding: '10px 24px', borderRadius: '8px', border: 'none',
              background: 'var(--accent, #e94560)', color: '#fff',
              fontSize: '15px', fontWeight: 600, cursor: 'pointer',
            }}
          >
            Reload
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
